/* ============
 * Recipe Transformer
 * ============
 *
 * The transformer for the product.
 */

import Transformer from './transformer';

export default class RecipeTransformer extends Transformer {

  static fetch(recipe) {
    return {
      id: recipe.id,
      organizationId: recipe.organization_id,
      recipeTypeId: recipe.recipe_type_id,
      recipeType: recipe.recipe_type,
      name: recipe.name,
      notes: recipe.notes,
      isActive: recipe.is_active,
      ingrediences: recipe.ingrediences,
      procedures: recipe.procedures,
      products: recipe.products,
    };
  }

  static send(recipe) {
    return {
      id: recipe.id,
      organization_id: recipe.organizationId,
      recipe_type_id: recipe.recipeTypeId,
      name: recipe.name,
      notes: recipe.notes,
      is_active: recipe.isActive,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/recipe.js